module.exports = __webpack_public_path__ + "img/fig.e6f68c2a.svg";